import { render, staticRenderFns } from "./DecimalField.vue?vue&type=template&id=25aa14ee&scoped=true"
import script from "./DecimalField.vue?vue&type=script&lang=ts"
export * from "./DecimalField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25aa14ee",
  null
  
)

export default component.exports